import React, { useEffect } from 'react'
import Incident from '../components/Incident'
import { useParams } from '@caudena/core/Router/router'
import { useAppLayoutSetter } from '@caudena/core/state'

export const PageIncident = () => {
  const { id } = useParams<{ id: string }>()
  const setLayout = useAppLayoutSetter()
  useEffect(() => {
    setLayout({ title: `Incident #${id}`, fixedHeader: true })
  }, [])
  return <Incident id={Number(id)} />
}
